import { Module } from "vuex";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { serializer } from "@/api/shared/serializer";
import { EventLocations } from "@/enums/EventLocations";
import { UserTypeEnum } from "@/enums/UserTypeEnum";
import { AuditLogsTier1 as Tier1, AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';

const careLevelsModule: Module<any, any> = {
  namespaced: false,
  state: {
    careLevels: [],
  },
  mutations: {
    setCareLevels(state, data) {
      state.careLevels = data;
    }
  },
  actions: {
    async getCareLevels({ commit }) {

    const wingsSnap = await firebase
      .firestore()
      .collection("eventLocations")
      .where("facilityId", "==", this.state.authModule.currentFacility)
      .where("type", "==", EventLocations.Wing).get()

    const wings = serializer.querySnapshotToDocuments(wingsSnap)

     return await firebase
        .firestore()
        .collection("careLevels")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .get()
        .then((querySnapshot) => {
          const data = serializer.querySnapshotToDocuments(querySnapshot)
           .map((x: any) => {
                const c = x
                c.wingsNames = wings?.filter(w => c.wingsIds?.includes(w.id)).map((y: any) => y.name) || []
                return c
            });

          commit("setCareLevels", data)
          return data
        })
    },

    async addCareLevel({ dispatch }, form) {

      form.facilityId = this.state.authModule.currentFacility
      form.createdById = this.state.authModule.user.id, 
      form.createdByType = UserTypeEnum.Staff
      form.typesOfRecordChanged = [`${Tier1.StaffHubSettings}: ${Tier2.StaffSettings}: ${Tier3.GroupingsAndLocs}`]

      await firebase
        .firestore()
        .collection("careLevels")
        .add(form)
        .then(() => {
          dispatch("getCareLevels");
        });
    },
    async updateCareLevel({ dispatch }, form) {
      await firebase
        .firestore()
        .collection("careLevels")
        .doc(form.id)
        .update({
          name: form.name,
          wingsIds: form.wingsIds,
          updatedById: this.state.authModule.user.id, 
          updatedByType: UserTypeEnum.Staff,
          typesOfRecordChanged: [`${Tier1.StaffHubSettings}: ${Tier2.StaffSettings}: ${Tier3.GroupingsAndLocs}`]
        })
        .then(() => {
          dispatch("getCareLevels");
        })
    },
    async deleteCareLevel({ dispatch }, careLevel) {

      const ref = firebase.firestore().collection("careLevels").doc(careLevel.id)
      
      await ref.update({
        deletedById: this.state.authModule.user.id,
        deletedByType: UserTypeEnum.Staff,
        typesOfRecordChanged: [`${Tier1.StaffHubSettings}: ${Tier2.StaffSettings}: ${Tier3.GroupingsAndLocs}`]
      })
      
      await ref.delete().then(async () => {
          dispatch("getCareLevels");
        });
    }
  }
};

export default careLevelsModule;